import { Component } from '@angular/core';
import { getNestedValue } from '../../util/table-v2.utils';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
import * as i2 from "@angular/common";
import * as i3 from "../../../../shared/directive/user-timezone-date.directive";
/**
 * @deprecated use v3 version of this component instead
 */
function DateRendererComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵelement(2, "div", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("date", ctx_r0.getNestedValue(ctx_r0.rowData, ctx_r0.columnKey))("dateFormat", ctx_r0.config == null ? null : ctx_r0.config.format);
  }
}
export class DateRendererComponent {
  translateService;
  rowData;
  columnKey;
  config;
  getNestedValue = getNestedValue;
  constructor(translateService) {
    this.translateService = translateService;
  }
  static ɵfac = function DateRendererComponent_Factory(t) {
    return new (t || DateRendererComponent)(i0.ɵɵdirectiveInject(i1.TranslateService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DateRendererComponent,
    selectors: [["geaui-date-renderer"]],
    decls: 1,
    vars: 1,
    consts: [[4, "ngIf"], [1, "date"], ["geauiUserTimezoneDate", "", 3, "date", "dateFormat"]],
    template: function DateRendererComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, DateRendererComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.rowData);
      }
    },
    dependencies: [i2.NgIf, i3.UserTimezoneDateDirective],
    styles: [".date[_ngcontent-%COMP%]{overflow:hidden}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateRendererComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-date-renderer',
      template: "<ng-container *ngIf=\"rowData\">\n  <div class=\"date\">\n    <div [date]=\"getNestedValue(rowData, columnKey)\" [dateFormat]=\"config?.format\" geauiUserTimezoneDate></div>\n  </div>\n</ng-container>\n",
      styles: [".date{overflow:hidden}\n"]
    }]
  }], () => [{
    type: i1.TranslateService
  }], null);
})();
